import React, { useEffect, useState } from "react";
import { societeId } from "../../_App/Redux/Slices/Auth/authSlice";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  currentpage,
  findListIncidentApi,
  listIncident,
  SeenIncident,
  totalpages,
} from "../../_App/Redux/Slices/incident/incidentSlice";
import AnnomalieList from "../../Components/Incident/IncidentList";
import PaginationLayout from "../../_Layouts/Pagination/PaginationLayout";
import { useTranslation } from "react-i18next";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastDanger } from "../../Shared/Toasts/ToastDanger";
import Swal from "sweetalert2";
import { formatDate } from "../../_App/Helpers/helpers";
import { useNavigate, useParams } from "react-router-dom";

export default function IncidentPage() {
  const navigate = useNavigate();
  const { numIncident } = useParams();
  const { t } = useTranslation();
  const societe_id = useAppSelector(societeId);
  const today = new Date();
  const lastMonth = new Date(today);
  lastMonth.setMonth(today.getMonth() - 1);
  // Filtres
  const [filters, setFilters] = useState({
    etat: "false", // "true" ou "false"
    dateDebut: formatDate(lastMonth),
    dateFin: formatDate(today),
  });
  const dispatch = useAppDispatch();
  const ListIncident = useAppSelector(listIncident);
  const current_page = useAppSelector(currentpage);
  const total_pages = useAppSelector(totalpages);

  const [ids, setListIds] = useState<string[]>([]);
  const [index, setindex] = useState(current_page || 1);

  // Charger la liste initiale + appliquer filtres
  useEffect(() => {
    if (societe_id ) {
      GetList(numIncident||undefined);
    }
  }, [societe_id, index, numIncident]);

  // Fonction pour appliquer les filtres
  const handleFilterChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
    setindex(1); // reset pagination quand on filtre
  };

  const GetList = async (num: any = undefined) => {
    
  if (!societe_id) return;
  // Conserver le paramètre numIncident dans l'URL
  const url = num ? `/incident/${num}` : "/incident";
  navigate(url, { replace: true });

  await dispatch(
    findListIncidentApi({
      societe_id,
      index,
      filtre: filters,
      numIncident:num,
    })
  );
};

  const marqueAsSeen = async () => {
    if (ids.length === 0) {
      ToastWarning("Aucun élément sélectionné");
      return;
    }

    const result = await Swal.fire({
      title: "Confirmer l'action",
      text: "Voulez-vous vraiment marquer ces incidents comme vus ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, confirmer",
      cancelButtonText: "Annuler",
    });

    if (!result.isConfirmed) return;

    try {
      const res: any = await dispatch(SeenIncident(ids)).unwrap();

      if (res && res.status === 200) {
        ToastSuccess("Incidents mis à jour avec succès");
        window.location.reload();
      } else {
        ToastDanger("Erreur lors de la mise à jour");
      }
    } catch (error: any) {
      ToastDanger(
        error?.message || "Une erreur est survenue lors de la mise à jour"
      );
    }
  };

  return (
    <div>
      <h2> {t("liste des incidents")} </h2>

      {/* 🔍 Filtres */}
      <div className="row layout-spacing bg-white p-3 rounded shadow-sm ">
        <div className="col-md-3">
          <label>{t("État")}</label>
          <select
            name="etat"
            className="form-select"
            value={filters.etat}
            onChange={handleFilterChange}
          >
            <option value="">{t("Tous")}</option>
            <option value={"true"}>{t("Vu")}</option>
            <option value={"false"}>{t("Non Vu")}</option>
          </select>
        </div>

        {/* <div className="col-md-3">
          <label>{t("Action")}</label>
          <input
            type="text"
            name="action"
            className="form-control"
            value={filters.action}
            onChange={handleFilterChange}
            placeholder={t("Rechercher une action")}
          />
        </div>*/}

        <div className="col-md-3">
          <label>{t("Date début")}</label>
          <input
            type="date"
            name="dateDebut"
            className="form-control"
            value={filters.dateDebut}
            onChange={handleFilterChange}
          />
        </div>

        <div className="col-md-3">
          <label>{t("Date fin")}</label>
          <input
            type="date"
            name="dateFin"
            className="form-control"
            value={filters.dateFin}
            onChange={handleFilterChange}
          />
        </div>
        <div
          className="col-1 mt-4"
          style={{ fontSize: "30px" }}
          onClick={()=>GetList(undefined)}
        >
          {" "}
          <i className="fas fa-search"></i>
        </div>
      </div>

      {/* 📋 Liste */}
      <AnnomalieList
        list={ListIncident}
        t={t}
        societe_id={societe_id}
        setListIds={setListIds}
        ids={ids}
        marqueAsSeen={marqueAsSeen}
        etat={filters.etat}
      />

      {/* 📄 Pagination */}
      <div className="row layout-spacing">
        <PaginationLayout
          index={index}
          nbrpage={current_page}
          totalpages={total_pages}
          setindex={setindex}
        />
      </div>
    </div>
  );
}
